import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import validation from "react-validation-mixin";
import strategy from "joi-validation-strategy";
import Joi from "joi";
import { StatesList } from "../../../../Helper/StatesList";
import InputMask from "react-input-mask";
import * as message from "../../../../config/CommonMessages";

class BillingInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: props.getUserData().billingAddress.firstname,
      lastname: props.getUserData().billingAddress.lastname,
      addressLine1: props.getUserData().billingAddress.addressLine1,
      addressLine2: props.getUserData().billingAddress.addressLine2,
      city: props.getUserData().billingAddress.city,
      state: props.getUserData().billingAddress.state,
      zip: props.getUserData().billingAddress.zip,
      phoneNumber: props.getUserData().billingAddress.phoneNumber,
    };
    this.validatorTypes = function() {
      var base = Joi.object().keys({
        firstname: Joi.string()
          .required()
          .label("First Name"),
        lastname: Joi.string()
          .required()
          .label("Last Name"),
        addressLine1: Joi.string()
          .required()
          .label("Address Line 1"),
        zip: Joi.string()
          .regex(new RegExp("^[0-9]{5}(?:-[0-9]{4})?$"))
          .required(),
        city: Joi.string()
          .required()
          .label("City"),
        state: Joi.string()
          .required()
          .label("State"),
        phoneNumber: Joi.string()
          .regex(new RegExp("^[0-9]{3}-[0-9]{3}-[0-9]{4}?$"))
          .required()
          .label("Phone Number"),
      });
      return base;
    };

    this.getValidatorData = this.getValidatorData.bind(this);
    this.renderHelpText = this.renderHelpText.bind(this);
    this.isValidated = this.isValidated.bind(this);
  }
  /**
   * @desc get validator data
   * this object is used to perform validation based on set joi validation schema
   */
  getValidatorData() {
    return {
      firstname: this.props.getUserData().billingAddress.firstname,
      lastname: this.props.getUserData().billingAddress.lastname,
      addressLine1: this.props.getUserData().billingAddress.addressLine1,
      city: this.props.getUserData().billingAddress.city,
      state: this.props.getUserData().billingAddress.state,
      zip: this.props.getUserData().billingAddress.zip,
      phoneNumber: this.props.getUserData().billingAddress.phoneNumber,
    };
  }

  /**
   * @desc check form is validate or not
   */
  isValidated() {
    return new Promise((resolve, reject) => {
      this.props.validate((error) => {
        if (error || this.state.validFirstName || this.state.validLastName) {
          reject();
          return false;
        }
        resolve();
        return true;
      });
    });
  }
  renderHelpText(message, id) {
    return (
      <div className="val-err-tooltip" key={id}>
        <span>{message}</span>
      </div>
    );
  }

  checkNameValidation(value) {
    // console.log("checkNameValidation value", value);
    let nameRegEx = /^[A-Za-z '-]{0,50}$/;
    if (nameRegEx.test(value)) {
      // console.log("matched");
      return true;
    } else {
      // console.log("not matched");
      return false;
    }
  }

  /**
   * @desc on change event of field
   * @param {*} event
   */
  onChange(event) {
    if (event.target.name === "firstname") {
      !this.checkNameValidation(event.target.value)
        ? this.setState({ validFirstName: true })
        : this.setState({ validFirstName: false });
    }
    if (event.target.name === "lastname") {
      !this.checkNameValidation(event.target.value)
        ? this.setState({ validLastName: true })
        : this.setState({ validLastName: false });
    }

    if (event.target.name === "zip") {
      this.setState({ zip: event.target.value });
      this.props.updateUserData("zip", event.target.value);

      //If zipcode is changed then get city and state from entered zicode
      let enteredZip = event.target.value.toString();
      let zipcode = enteredZip.replace(/\-/g, "");

      if (
        event.target.value !== "000000" &&
        (zipcode.length === 5 || zipcode.length === 9)
      ) {
        this.props.getCityState(enteredZip).then((res) => {
          this.setState({ city: res.city, state: res.state });
          this.props.updateUserData("city", res.city);
          this.props.updateUserData("state", res.state);
        });
      } else {
        this.setState({ city: "", state: "" });
        this.props.updateUserData("city", "");
        this.props.updateUserData("state", "");
      }
    } else {
      this.setState({ [event.target.name]: event.target.value });
      this.props.updateUserData(event.target.name, event.target.value);
    }
  }
  /**
   * @desc get error message for given field from errlist from validator
   */
  getErrorMsg(field, errsList) {
    var err = "";
    if (field === "firstname" || field === "lastname") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (field === "firstname") {
          err = message.ENTER_FIRST_NAME;
        }
        if (field === "lastname") {
          err = message.ENTER_LAST_NAME;
        }
      }
    }
    if (field === "addressLine1" || field === "city" || field === "state") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (field === "addressLine1") {
          err = message.ENTER_ADDRESS_LINE;
        }
        if (field === "city") {
          err = message.ENTER_CITY;
        }
        if (field === "state") {
          err = message.SELECT_STATE;
        }
      }
    }
    if (field === "zip") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_ZIP;
        }
        if (errsList[field].length === 1) {
          err = message.ENTER_VALID_ZIP;
        }
      }
    }

    if (field === "phoneNumber") {
      if (
        errsList[field] !== undefined &&
        errsList[field] !== null &&
        errsList[field] !== ""
      ) {
        if (errsList[field].length === 2) {
          err = message.ENTER_PHONE;
        }
        if (errsList[field].length === 1) {
          err = message.PHONE_10_DIGIT;
        }
      }
    }

    return err;
  }

  render() {
    var stateDropDownValue = [];
    for (var key in StatesList) {
      var opt = (
        <option key={key} value={key}>
          {StatesList[key]}
        </option>
      );
      stateDropDownValue.push(opt);
    }
    return (
      <div className="step-content">
        <Form className="form-sm form-admin">
          <Row>
            <Col xs={12}>
              <h4 className="title-blue mb-3">Billing Information</h4>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  First Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.firstname}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="firstname"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("firstname")}
                />

                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("firstname", this.props.errors)
                  )}
                  {this.state.validFirstName
                    ? message.ENTER_VALID_FIRST_NAME
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
            <Col xs={12} sm={6}>
              <Form.Group controlId="">
                <Form.Label>
                  Last Name<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  maxLength="50"
                  defaultValue={this.state.lastname}
                  className="field_ucfirst"
                  onChange={this.onChange.bind(this)}
                  name="lastname"
                  type="text"
                  size="lg"
                  onBlur={this.props.handleValidation("lastname")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("lastname", this.props.errors)
                  )}
                  {this.state.validLastName
                    ? message.ENTER_VALID_LAST_NAME
                    : ""}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>
                  Address Line 1<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="addressLine1"
                  className="field_ucfirst"
                  defaultValue={this.state.addressLine1}
                  onChange={this.onChange.bind(this)}
                  size="lg"
                  onBlur={this.props.handleValidation("addressLine1")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("addressLine1", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>Address Line 2</Form.Label>
                <Form.Control
                  type="text"
                  name="addressLine2"
                  className="field_ucfirst"
                  defaultValue={this.state.addressLine2}
                  onChange={this.onChange.bind(this)}
                  size="lg"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Label>
                Zip Code<span style={{ color: "#FFFFFF" }}> *</span>
              </Form.Label>
              <Form.Group controlId="">
                <Form.Control
                  type="text"
                  name="zip"
                  defaultValue={this.state.zip}
                  onChange={this.onChange.bind(this)}
                  size="lg"
                  onBlur={this.props.handleValidation("zip")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("zip", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>
                  City<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={this.state.city}
                  onChange={this.onChange.bind(this)}
                  size="lg"
                  onBlur={this.props.handleValidation("city")}
                />
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("city", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>
                  State<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <div className="c-select">
                  <select
                    name="state"
                    className="form-control"
                    id=""
                    value={this.state.state}
                    onChange={this.onChange.bind(this)}
                    onBlur={this.props.handleValidation("state")}
                  >
                    <option value="">Select</option>
                    {stateDropDownValue}
                  </select>
                </div>
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("state", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Form.Group controlId="">
                <Form.Label>
                  Phone Number<span style={{ color: "#FFFFFF" }}> *</span>
                </Form.Label>
                <InputMask
                  mask="999-999-9999"
                  maskChar=""
                  formControlProps={{
                    fullWidth: true,
                  }}
                  className="form-control form-control-lg"
                  value={this.state.phoneNumber}
                  name="phoneNumber"
                  onChange={this.onChange.bind(this)}
                  onBlur={this.props.handleValidation("phoneNumber")}
                >
                  {(inputProps) => <Form.Control {...inputProps} />}
                </InputMask>
                <Form.Text style={{ color: "#FFFFFF" }}>
                  {this.renderHelpText(
                    this.getErrorMsg("phoneNumber", this.props.errors)
                  )}
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

BillingInfo.propTypes = {
  errors: PropTypes.object,
  validate: PropTypes.func,
  isValid: PropTypes.func,
  handleValidation: PropTypes.func,
  getValidationMessages: PropTypes.func,
  clearValidations: PropTypes.func,
  getUserData: PropTypes.func,
  updateUserData: PropTypes.func,
};

export default validation(strategy)(BillingInfo);
